import angular from 'angular';
import loanVariationSummary from './loanVariationSummary';

export default angular
  .module('scenes.loanVariationSummary', [])
  .component('loanVariationSummary', loanVariationSummary).name;
